export default __webpack_public_path__ + "static/step0401-b62e8c574e3a34e35183158de87b6c57.jpg";